/**
 * @module M/control/XYLocatorControl
 */

import XYLocatorImplControl from 'impl/xylocatorcontrol';
import template from 'templates/xylocator';
import { getValue } from './i18n/language';


export default class XYLocatorControl extends M.Control {
  /**
   * @classdesc
   * Main constructor of the class. Creates a PluginControl
   * control
   *
   * @constructor
   * @extends {M.Control}
   * @api stable
   */
  constructor() {
    // 1. checks if the implementation can create PluginControl
    if (M.utils.isUndefined(XYLocatorImplControl)) {
      M.exception('La implementación usada no puede crear controles XYLocatorControl');
    }
    // 2. implementation of this control
    const impl = new XYLocatorImplControl();
    super(impl, 'XYLocator');
  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  createView(map) {
    return new Promise((success, fail) => {
      const html = M.template.compileSync(template, {
        vars: {
          translations: {
            title: getValue('title'),
            coordinateSystem: getValue('coordinateSystem'),
            longitude: getValue('longitude'),
            latitude: getValue('latitude'),
            locate: getValue('locate'),
          },
        },
      });
      // Añadir código dependiente del DOM
      this.template_ = html;
      this.template_.querySelector('button#m-xylocator-limpiar').addEventListener('click', () => this.clear_());
      this.template_.querySelector('select#m-xylocator-srs').addEventListener('change', evt => this.manageInputs_(evt));
      this.template_.querySelector('button#m-xylocator-loc').addEventListener('click', evt => this.calculate_(evt));
      success(html);
    });
  }

  /**
   * This function is called on the control activation
   *
   * @public
   * @function
   * @api stable
   */
  activate() {}

  /**
   * This function is called on the control deactivation
   *
   * @public
   * @function
   * @api stable
   */
  deactivate() {}

  /**
   * This function gets activation button
   *
   * @public
   * @function
   * @param {HTML} html of control
   * @api stable
   */
  getActivationButton(html) {
    return html.querySelector('.m-xylocator button');
  }

  /**
   * @private
   */
  locator_(coords) {
    const x = coords[0];
    const y = coords[1];
    const xFloat = parseFloat(x);
    const yFloat = parseFloat(y);
    if (!isNaN(xFloat) && !isNaN(yFloat)) {
      this.map_.setCenter(`${x},${y}*false`).setZoom(10);
      /*
      let polygon = ol.geom.Polygon.fromExtent(extent);
          let coords = polygon.getCoordinates()[0];
          let centerX = (coords[0][0] + coords[2][0]) / 2;
          let centerY = (coords[0][1] + coords[2][1]) / 2;
          let center = [centerX, centerY];

          const macPlugin = pluginList.find(p=>p.name==="Mapaalacarta");
          let frameCoords = macPlugin.getCoordinates()[1];
          let oldCenterX = (frameCoords[0][0] + frameCoords[2][0]) / 2;
          let oldCenterY = (frameCoords[0][1] + frameCoords[2][1]) / 2;
          let oldCenter = [oldCenterX, oldCenterY];

          let deltaX = center[0] - oldCenter[0];
          let deltaY = center[1] - oldCenter[1];
          macPlugin.translateAll(deltaX, deltaY);
      */
      const macPlugin = this.map_.getPlugins().find(p => p.name === 'Mapaalacarta');
      /*
      let vectorLayer;
      const layers = this.map_.getMapImpl().getLayers().getArray();
      for (let h = 0; h < layers.length; h += 1) {
        if (layers[h].get('id') === 'frame_layer') {
          vectorLayer = h;
          break;
        }
      }

      const features = layers[vectorLayer].getSource().getFeatures();

      let i;
      for (let j = 0; j < features.length; j += 1) {
        if (features[j].getProperties().id === 'frame_feature') {
          i = j;
        }
      }
      */

      // const coordinatesArray = features[i].getGeometry().getCoordinates()[1];
      const coordinatesArray = macPlugin.getCoordinates()[1];
      const x0 = coordinatesArray[0][0];
      const x2 = coordinatesArray[2][0];
      const y0 = coordinatesArray[0][1];
      const y2 = coordinatesArray[2][1];

      const centerX = parseFloat((x0 + x2) / 2);
      const centerY = parseFloat((y0 + y2) / 2);

      const deltaX = xFloat - centerX;
      const deltaY = yFloat - centerY;

      macPlugin.translateAll(deltaX, deltaY);

      /*
      features.forEach((feature) => {
        if (feature.get('id') === 'frame_feature' || feature.get('id') === 'exterior_feature'
          || feature.get('id') === 'infor_feature') {
          feature.getGeometry().translate(deltaX, deltaY);
        }
      });
      */
    } else {
      M.dialog.error(getValue('incorrectCoordFormat'), 'Error');
    }
  }

  manageInputs_(evt) {
    const selectTarget = evt.target;
    const origin = selectTarget.options[selectTarget.selectedIndex].value;
    if (origin.indexOf('4258') >= 0) {
      const divToHidden = document.querySelector('div#m-xylocator-utm');
      divToHidden.style.display = 'none';
      const divToShow = document.querySelector('div#m-xylocator-latlon');
      divToShow.style.display = 'block';
    } else {
      const divToHidden = document.querySelector('div#m-xylocator-latlon');
      divToHidden.style.display = 'none';
      const divToShow = document.querySelector('div#m-xylocator-utm');
      divToShow.style.display = 'block';
    }
  }

  calculate_(evt) {
    const selectTarget = document.querySelector('select#m-xylocator-srs');
    const origin = selectTarget.options[selectTarget.selectedIndex].value;

    let x = -1;
    let y = -1;
    if (origin.indexOf('4258') >= 0) {
      const xString = document.querySelector('div#m-xylocator-latlon input#LON').value;
      const yString = document.querySelector('div#m-xylocator-latlon input#LAT').value;
      try {
        const xArray = xString;
        const yArray = yString;
        x = parseFloat(xArray);
        y = parseFloat(yArray);
      } catch (ex) {
        M.dialog.error(getValue('incorrectCoord'), 'Error');
      }
    } else {
      const xString = document.querySelector('div#m-xylocator-utm input#UTM-X').value;
      const yString = document.querySelector('div#m-xylocator-utm input#UTM-Y').value;
      x = parseFloat(xString);
      y = parseFloat(yString);
    }
    const originProj = ol.proj.get(origin);
    const destProj = ol.proj.get('EPSG:3857');
    const coordinatesTransform = ol.proj.transform([x, y], originProj, destProj);
    this.locator_(coordinatesTransform);
  }

  clear_() {
    this.template_.querySelector('input#UTM-X').value = '';
    this.template_.querySelector('input#UTM-Y').value = '';
    this.template_.querySelector('input#LON').value = '';
    this.template_.querySelector('input#LAT').value = '';
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api stable
   */
  equals(control) {
    return control instanceof XYLocatorControl;
  }
}
